export enum BrowserEnum {
  CHROME = 'CHROME',
  FIREFOX = 'FIREFOX',
  SAFARI = 'SAFARI',
  EDGE = 'EDGE',
}

export enum WebPushNotificationTypeEnum {
  OFFER = 'OFFER',
  RECEIPT = 'RECEIPT',
  COUPON = 'COUPON',
}

export interface SelectedStoreDTO {
  storeId: string;
  types: WebPushNotificationTypeEnum[];
  tagIds: string[];
}

export interface WebPushSubscriptionOutDTO {
  endpoint: string;
  expirationTime: number | null;
  deviceId: string;
  userId: string;
  browser: BrowserEnum;
  selectedStores: SelectedStoreDTO[];
  keys?: {
    p256dh: string;
    auth: string;
  };
}

export type WebPushSubscriptionInfoInDTO = Partial<
  Pick<WebPushSubscriptionOutDTO, 'deviceId' | 'endpoint' | 'expirationTime' | 'keys'>
>;
export interface WebPushSubscriptionInDTO extends WebPushSubscriptionOutDTO {
  franchiseId: string;
  id: string;
}
